import { useState } from "react";
import { Link } from "react-router-dom";
import ComingSoonPopup from "./ComingSoonPopup";

export default function Footer() {
  const [popupOpen, setPopupOpen] = useState(false);

  const showComingSoon = (e) => {
    e.preventDefault();
    setPopupOpen(true);
  };

  return (
    <>
      <footer>
        <div className="container">

          <div className="footer-container">

            <div className="footer-col">
              <h4>R Vibes Homoeopathy</h4>
              <p>The Healing Energy. <br/><br/>Committed to Quality Homoeopathic & Natural Care.</p>

              <div className="social-icons">
                <button onClick={showComingSoon} className="social-icon fake-link"><i className="fab fa-facebook-f"></i></button>
                <button onClick={showComingSoon} className="social-icon fake-link"><i className="fab fa-instagram"></i></button>
                <button  onClick={showComingSoon} className="social-icon fake-link"><i className="fab fa-twitter"></i></button>
                <button onClick={showComingSoon} className="social-icon fake-link" ><i className="fab fa-linkedin-in"></i></button>
              </div>
            </div>

            <div className="footer-col">
              <h4>Quick Links</h4>
              <ul className="footer-links">
                <li><Link to="/">Home</Link></li>
                <li><Link to="/products">Products</Link></li>
                <li><Link to="/about">About Us</Link></li>
              </ul>
            </div>

            <div className="footer-col">
              <h4>Policies</h4>
              <ul className="footer-links">
                <li><button className="fake-link" onClick={showComingSoon}>Shipping Policy</button></li>
                <li><button className="fake-link" onClick={showComingSoon}>Return Policy</button></li>
                <li><button className="fake-link" onClick={showComingSoon}>Privacy Policy</button></li>
                <li><button className="fake-link" onClick={showComingSoon}>Terms & Conditions</button></li>
              </ul>
            </div>

            <div className="footer-col">
              <h4>Newsletter</h4>
              <p>Subscribe to our newsletter.</p>

              <form className="newsletter-form" onSubmit={showComingSoon}>
                <input type="email" placeholder="Your Email Address" />
                <button type="submit"><i className="fas fa-arrow-right"></i></button>
              </form>
            </div>

          </div>

          <div className="footer-bottom">
            <p>© 2025 R Vibes Homoeopathy Pvt. Ltd. All Rights Reserved.</p>
          </div>

        </div>
      </footer>

      <ComingSoonPopup open={popupOpen} onClose={() => setPopupOpen(false)} />
    </>
  );
}
